import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./utils/authInterceptor";
import "./input.css";
import { resetThemeColor } from "./utils/themeColor";

const app = createApp(App);

const root = document.documentElement;

resetThemeColor();
root.style.setProperty("--leftNavBg", process.env.VUE_APP_LEFT_NAV_BG);
root.style.setProperty("--hoverColor", process.env.VUE_APP_HOVER_COLOR);
root.style.setProperty("--whiteBG", process.env.VUE_APP_WHITE_BG);
root.style.setProperty("--grayBG", process.env.VUE_APP_GRAY_BG);
root.style.setProperty("--graySecondaryBg", process.env.VUE_APP_GRAY_SECONDARY);
root.style.setProperty("--grayTertiaryBg", process.env.VUE_APP_GRAY_TERTIARY);
root.style.setProperty("--brand-rgb", "0, 39, 82");
root.style.setProperty("--examSelect", "#002752");
root.style.setProperty("--examSelectRgb", "0, 39, 82");

// A route's CSS failing to preload surfaces as "Unable to preload CSS for …", which the
// chunk-error check in router/index.js doesn't match; recover the same way it does.
router.onError((error, to) => {
  if (!error?.message?.includes("Unable to preload CSS")) return;
  if (to?.fullPath) {
    window.location.href = to.fullPath;
  } else {
    window.location.reload();
  }
});

app.use(store);
app.use(router);

app.mount("#app");

if (process.env.NODE_ENV !== "production") {
  window.$store = store;
}
